<template>
    <div class="lottery">
        <h2>{{ lotteryExtended.name }}</h2>
        <dl v-for="(set, index) in lotteryExtended.sets" >
            <dt v-text="set.label || 'Set ' + (index + 1)"></dt>
            <dd>
                <ul class="set">
                    <li v-for="number in set.extended" class="set__number"
                        v-bind:class="{'drawn': isDrawn(set, number), 'locked': isLocked(set, number)}"
                        v-on:click="toggleLock(set, number, index)">
                        {{ number }}
                    </li>
                </ul>
            </dd>
        </dl>

        <my-button v-on:click="draw">Zufallszahlen generieren</my-button>
    </div>
</template>

<script>
    import { shuffle } from '../utils/helpers';
    import MyButton from '@/components/Button';

    export default {
        name: 'draw-from-sets',
        props: {
            lottery: {
                type: Object
            }
        },
        components: {
            MyButton
        },
        computed: {
            lotteryExtended () {
                return Object.assign({}, this.lottery);
            }
        },
        methods: {
            extendRange (arr) {
                let top = arr[1] + 1;
                let bottom = arr[0];
                if (arr[0] === 0) {
                    bottom = 0;
                }
                return Array.from(Array(top).keys()).splice(bottom, top);
            },
            draw () {
                this.lottery.sets.forEach((e, i, a) => {
                    let pool = e.extended.slice(0);
                    let count = e.draw;
                    let locked = [];
                    if (e.locked.length > 0) {
                        e.locked.forEach((e) => {
                            let index = pool.indexOf(e);
                            pool.splice(index, 1);
                            count--;
                            locked.push(e);
                        });
                    }
                    e.drawn = shuffle(pool).splice(0, count);
                    e.drawn.push(...locked);
                });
            },
            toggleLock (set, num, setIndex) {
                if (set.locked.indexOf(num) === -1) {
                    if (set.locked.length < this.lotteryExtended.sets[setIndex].draw) {
                        set.locked.push(num);
                    }
                } else {
                    let index = set.locked.indexOf(num);
                    set.locked.splice(index, 1);
                }
            },
            isDrawn (set, num) {
                return set.drawn.indexOf(num) >= 0;
            },
            isLocked (set, num) {
                return set.locked.indexOf(num) >= 0;
            }
        },
        created () {
            const that = this;
            this.lotteryExtended.sets.forEach((e, i, a) => {
                that.$set(e, 'extended', this.extendRange(e.range));
                that.$set(e, 'drawn', []);
                that.$set(e, 'locked', []);
            });
        }
    }
</script>

<style scoped lang="scss">
    .lottery {
        margin-bottom: 2rem;
    }

    h2 {
        margin-bottom: 1rem;
    }

    dt {
        line-height: 2em;
    }
    dd {
        margin: 0;
    }

    .set {
        list-style: none;

        padding: 0;
        display: flex;
        flex-wrap: wrap;
    }

    .set__number {
        height: 2em;
        width: 2em;
        border: 1px solid #ccc;
        line-height: 2em;
        text-align: center;
        margin: 0 0.2em 0.2em 0;
        cursor: default;
    }

    .drawn {
        background-color: burlywood;
    }

    .locked {
        position: relative;

        &:before {
            content: "🔒";
            font-family: Arial;
            position: absolute;
            right: 0;
            bottom: 0;
            transform: translateY(50%);
            line-height: 1;
        }
    }
</style>



// WEBPACK FOOTER //
// DrawFromSets.vue?5456a2bb